export default {
  mounted () {
    this.$upgradeElement()
  }
}



// WEBPACK FOOTER //
// ./src/components/Mixins/uiComponent.js